import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import styles from './StepsV2.css';

const cx = classnames.bind(styles);

const EMAIL_STEP = 'email';
const PLAN_STEP = 'plan';
const CHECKOUT_STEP = 'checkout';

const STEPS = [
    { id: EMAIL_STEP, label: 'Email' },
    { id: PLAN_STEP, label: 'Plan' },
    { id: CHECKOUT_STEP, label: 'Checkout' }
];

function StepsV2({ currentStepId }) {
    const currentIndex = STEPS.findIndex(step => step.id === currentStepId);

    return (
        <div className={styles.root}>
            <ul className={styles.list}>
                {STEPS.map((step, index) => (
                    <li key={step.id} className={styles.step}>
                        <span className={cx('number', { filled: index <= currentIndex })}>
                            {index < currentIndex ? <Icon name='checked' className={styles.checkmark} /> : index + 1}
                        </span>
                        <span className={styles.label}>{step.label}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
}

StepsV2.propTypes = {
    currentStepId: PropTypes.oneOf(STEPS.map(step => step.id)).isRequired
};

export {
    StepsV2,
    EMAIL_STEP,
    PLAN_STEP,
    CHECKOUT_STEP
};
